
import * as React from "react";
import {SettingsService} from "../../services/SettingsService";
import {getContainer} from "../../ioc/IOCSetup";
import {LoadingViewState, RouterView} from "../RouterView";
import {Form, FormListener} from "../form/Form";
import {RouteComponentProps, withRouter} from "react-router";
import {Fragment} from "react";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {AccountService} from "../../services/AccountService";
import {Validators} from "../form/Validators";
import {Settings, TransferLimit} from "../../http/protocol";

interface Props extends RouteComponentProps {

}

interface State extends LoadingViewState{
    settings?: Settings;
    validationMap? : any;

}

export class SettingsTransferLimitsView extends RouterView<Props,State> implements FormListener<Settings>{

    settingsService: SettingsService;
    accountService : AccountService;

    constructor(props:Props) {
        super(props);

        this.settingsService = getContainer().getSettingsService();
        this.accountService = getContainer().getAccountService();

        this.state = {validationMap : {}, loading : true};
    }


    loadContent(): Promise<any> | undefined {
        return Promise.all([
            this.settingsService.getSettings(),
            this.accountService.getCurrencies()
        ]).then((data) => {
            let settings: Settings = data[0] ? data[0] : {};
            let transferLimits : TransferLimit[] = [];
            transferLimits.push(...(data[0].transferLimits as any));
            if(data[1]) {
                data[1].forEach((curr) => {
                    if(transferLimits.findIndex(x => x.currency === curr.code) === -1) {
                        transferLimits.push({currency : curr.code, maxDepositAmount : undefined, maxWithdrawAmount : undefined, minDepositAmount : undefined, minWithdrawAmount : undefined});
                    } else {
                        console.log("transfer limits for that currency already exist!")
                    }
                });
            }
            settings.transferLimits = transferLimits;
            console.log("Transfer limits page: ", settings);

            this.setState({settings:settings});
        });
    }
    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        super.componentDidUpdate(prevProps, prevState);

    }

    formDidUpdate(formModel:Settings, validationMap : any) {
        this.setState({ settings : formModel, validationMap : validationMap});
    }

    onSubmit():Promise<any> {
        if(!this.state.settings) {
            return Promise.reject("Unable to save settings");
        }
        let settings = this.state.settings;
        settings.transferLimits = this.checkForEmptyStringAndSetToNull();
        console.log(settings)
        return this.settingsService.saveSettings(settings).catch(err=>{
            throw new Error("Unable to create/save settings");
        });
    }

    onSubmitError(){}

    getTitle() : string {
        return "Transfer Limits Settings";
    }

    checkForEmptyStringAndSetToNull() {
        if(this.state.settings && this.state.settings.transferLimits) {
            let result:any = [];
            this.state.settings.transferLimits.forEach((obj:any) => {
                if(obj) {
                    console.log("checkForEmptyStringAndSetToNull");
                    let currencyObj:any = {};
                    for(let key in obj) {
                        if(obj[key]==null) {
                            currencyObj[key] = null;
                        } else {
                            currencyObj[key] = obj[key];
                        }
                    }
                    result.push(currencyObj);
                }
            });
            return result;
        }

    }

    getTransferLimitsSettings() {
        if(this.state.settings && this.state.settings.transferLimits) {
            let result = this.state.settings.transferLimits.map((obj : TransferLimit, index) => {
                return (
                    <div key={`${obj.currency}-${index}`}>
                        <label>{obj.currency}</label>
                        <FormGroup className="form-group mb-3" model={`transferLimits[${index}].minDepositAmount`}>
                            <label>Minimum DEPOSIT Amount</label>
                            <FormInput className="form-control" model={`transferLimits[${index}].minDepositAmount`} type="number" validators={[Validators.number()]}/>
                            <span className={"help-block"}>Set min Deposit amount - Empty field equals NO LIMIT</span>
                        </FormGroup>
                        <FormGroup className="form-group mb-3" model={`transferLimits[${index}].maxDepositAmount`}>
                            <label>Maximum DEPOSIT Amount</label>
                            <FormInput className="form-control" model={`transferLimits[${index}].maxDepositAmount`} type="number" validators={[Validators.number()]}/>
                            <span className={"help-block"}>Set max Deposit amount - Empty field equals NO LIMIT</span>
                        </FormGroup>
                        <FormGroup className="form-group mb-3" model={`transferLimits[${index}].minWithdrawAmount`}>
                            <label>Minimum WITHDRAW Amount</label>
                            <FormInput className="form-control" model={`transferLimits[${index}].minWithdrawAmount`} type="number" validators={[Validators.number()]}/>
                            <span className={"help-block"}>Set max Withdraw amount - Empty field equals NO LIMIT</span>
                        </FormGroup>
                        <FormGroup className="form-group mb-3" model={`transferLimits[${index}].maxWithdrawAmount`}>
                            <label>Maximum WITHDRAW Amount</label>
                            <FormInput className="form-control" model={`transferLimits[${index}].maxWithdrawAmount`} type="number" validators={[Validators.number()]}/>
                            <span className={"help-block"}>Set max Withdraw amount - Empty field equals NO LIMIT</span>
                        </FormGroup>
                        <FormGroup className="form-group mb-3" model={`transferLimits[${index}].defaultDepositAmount`}>
                            <label>Default DEPOSIT Amount</label>
                            <FormInput className="form-control" model={`transferLimits[${index}].defaultDepositAmount`} type="number" validators={[Validators.number()]}/>
                            <span className={"help-block"}>For payments that has prefilled amounts, this will be the middle preset deposit amount upon first deposit</span>
                        </FormGroup>
                    </div>
                )
            });
            return result;
        }

    }

    renderContent() {
        if(!this.state.settings) {
            return <span></span>
        }
        return(
            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.settings} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Settings was updated successfully"/>
                                    {this.getTransferLimitsSettings()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Settings</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>


            </Fragment>
        )
    }

}

export default withRouter(SettingsTransferLimitsView);